<template>
  <Teleport to="body">
    <div
      class="events-log-panel-wrapper l11-waap"
      :style="`--anchor-top: ${anchorTop}px`"
      ref="panelRef"
    >
      <div class="top-navbar">
        <div class="top-navbar-left">
          <rbz-form-button
            v-if="isArgumentsContent"
            variant="tertiary"
            icon="IconArrowBack"
            :label="t('eventsLog.panel.additionalDetailsCard.arguments')"
            @button-click="
              isArgumentsContent = false;
              isAdditionalDetailsCardCollapsed = false;
            "
            classes="return-to-panel-content-button"
            data-qa="return-to-panel-content-button"
          />
        </div>
        <div class="top-navbar-right">
          <div class="buttons-wrapper">
            <div v-if="!isArgumentsContent" class="navigation-buttons">
              <rbz-form-button
                variant="tertiary"
                icon="IconSortArrow"
                :icon-props="{
                  color: previousEventLogDisabled ? 'shuttle-gray' : 'dusty-gray',
                  direction: 'down',
                }"
                v-b-tooltip.bottom="t('eventsLog.panel.previous')"
                classes="panel-button"
                class="previous-log-button"
                data-qa="previous-log-button"
                :disabled="previousEventLogDisabled"
                :ignore-update-in-process="true"
                @button-click="emit('previous-log')"
              />
              <rbz-form-button
                variant="tertiary"
                icon="IconSortArrow"
                :icon-props="{
                  color: nextEventLogDisabled ? 'shuttle-gray' : 'dusty-gray',
                  direction: 'up',
                }"
                v-b-tooltip.bottom="t('eventsLog.panel.next')"
                classes="panel-button"
                class="next-log-button"
                data-qa="next-log-button"
                :disabled="nextEventLogDisabled"
                :ignore-update-in-process="true"
                @button-click="emit('next-log')"
              />
            </div>
            <rbz-form-button
              variant="tertiary"
              icon="IconClose"
              :icon-props="{ color: 'biscay' }"
              v-b-tooltip.bottom="t('eventsLog.panel.close')"
              classes="panel-button"
              class="close-panel-button"
              data-qa="close-panel-button"
              :ignore-update-in-process="true"
              @button-click="emit('close-panel')"
            />
          </div>
        </div>
      </div>
      <div class="events-log-panel-content">
        <template v-if="!isArgumentsContent">
          <div class="rbz-card white events-log-panel-card main-card">
            <div class="date-wrapper">
              <div
                class="date-value rbz-text-small is-clickable"
                v-b-tooltip="eventLog.timestamp"
                @contextmenu="openContextMenu($event, 'timestamp', eventLog.timestamp)"
                @dblclick="doubleClick($event, 'timestamp', eventLog.timestamp)"
              >
                {{ eventLogDateTime }}
              </div>
            </div>
            <div class="card-content">
              <div class="entries-wrapper">
                <div class="entry entry-value-columns-2 source-entry">
                  <div class="entry-key">
                    {{ t('eventsLog.panel.mainCard.entries.source') }}
                  </div>
                  <div class="entry-value">
                    <div
                      class="entry-value-item is-clickable ip-entry"
                      @contextmenu="openContextMenu($event, 'ip', eventLog.ip)"
                      @dblclick="doubleClick($event, 'ip', eventLog.ip)"
                    >
                      <div class="entry-value-item-key">
                        {{ t('eventsLog.panel.mainCard.entries.sourceValue.ip') }}
                      </div>
                      <div
                        class="entry-value-item-value ellipsis"
                        ref="eventLogIpRef"
                        v-b-tooltip="eventLogIpTooltip"
                      >
                        {{ eventLog.ip }}
                      </div>
                    </div>
                    <div
                      class="entry-value-item is-clickable asn-entry"
                      @contextmenu="openContextMenu($event, 'asn', eventLog.asn)"
                      @dblclick="doubleClick($event, 'asn', eventLog.asn)"
                    >
                      <div class="entry-value-item-key">
                        {{ t('eventsLog.panel.mainCard.entries.sourceValue.asn') }}
                      </div>
                      <div
                        class="entry-value-item-value ellipsis"
                        ref="eventLogAsnRef"
                        v-b-tooltip="eventLogAsnTooltip"
                      >
                        {{ eventLog.asn }}
                      </div>
                    </div>
                  </div>
                  <div class="entry-value">
                    <div
                      class="entry-value-item is-clickable country-entry"
                      @contextmenu="openContextMenu($event, 'country', eventLog.country)"
                      @dblclick="doubleClick($event, 'country', eventLog.country)"
                    >
                      <div class="entry-value-item-key">
                        {{ t('eventsLog.panel.mainCard.entries.sourceValue.country') }}
                      </div>
                      <div
                        class="entry-value-item-value ellipsis"
                        ref="eventLogCountryRef"
                        v-b-tooltip="eventLogCountryTooltip"
                      >
                        {{ eventLog.country }}
                      </div>
                    </div>
                    <div
                      class="entry-value-item is-clickable organization-entry"
                      @contextmenu="openContextMenu($event, 'organization', eventLog.organization)"
                      @dblclick="doubleClick($event, 'organization', eventLog.organization)"
                    >
                      <div class="entry-value-item-key">
                        {{ t('eventsLog.panel.mainCard.entries.sourceValue.organization') }}
                      </div>
                      <div
                        class="entry-value-item-value ellipsis"
                        ref="eventLogOrganizationRef"
                        v-b-tooltip="eventLogOrganizationTooltip"
                      >
                        {{ eventLog.organization }}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="entry entry-value-columns-1 user-agent-entry is-clickable"
                  @contextmenu="openContextMenu($event, 'user_agent', eventLog['user_agent'])"
                  @dblclick="doubleClick($event, 'user_agent', eventLog['user_agent'])"
                >
                  <div class="entry-key">
                    {{ t('eventsLog.panel.mainCard.entries.userAgent') }}
                  </div>
                  <div class="entry-value">
                    <div
                      class="entry-value-item"
                      ref="eventLogUserAgentRef"
                      v-b-tooltip="eventLogUserAgentTooltip"
                    >
                      <span>
                        {{ eventLog['user_agent'] }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="entry entry-value-columns-1 url-entry">
                  <div class="entry-key">
                    {{ t('eventsLog.panel.mainCard.entries.url') }}
                  </div>
                  <div class="entry-value">
                    <div
                      class="entry-value-item is-clickable host-entry"
                      v-if="eventLog.host"
                      @contextmenu="openContextMenu($event, 'host', eventLog.host)"
                      @dblclick="doubleClick($event, 'host', eventLog.host)"
                    >
                      <div class="entry-value-item-key">
                        {{ t('eventsLog.panel.mainCard.entries.urlValue.host') }}
                      </div>
                      <div
                        class="entry-value-item-value ellipsis"
                        ref="eventLogHostRef"
                        v-b-tooltip="eventLogHostTooltip"
                      >
                        {{ eventLog.host }}
                      </div>
                    </div>
                    <div
                      class="entry-value-item is-clickable path-entry"
                      v-if="eventLog.path"
                      @contextmenu="openContextMenu($event, 'path', eventLog.path)"
                      @dblclick="doubleClick($event, 'path', eventLog.path)"
                    >
                      <div class="entry-value-item-key">
                        {{ t('eventsLog.panel.mainCard.entries.urlValue.path') }}
                      </div>
                      <div
                        class="entry-value-item-value ellipsis"
                        ref="eventLogPathRef"
                        v-b-tooltip="eventLogPathTooltip"
                      >
                        {{ eventLog.path }}
                      </div>
                    </div>
                    <div
                      class="entry-value-item is-clickable query-entry"
                      v-if="eventLog.query"
                      @contextmenu="openContextMenu($event, 'query', eventLog.query)"
                      @dblclick="doubleClick($event, 'query', eventLog.query)"
                    >
                      <div class="entry-value-item-key">
                        {{ t('eventsLog.panel.mainCard.entries.urlValue.queryParameters') }}
                      </div>
                      <div
                        class="entry-value-item-value ellipsis"
                        ref="eventLogQueryRef"
                        v-b-tooltip="eventLogQueryTooltip"
                      >
                        {{ eventLog.query }}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="entry entry-value-columns-1 referer-entry is-clickable"
                  @contextmenu="openContextMenu($event, 'referer', eventLog.referer || '')"
                  @dblclick="doubleClick($event, 'referer', eventLog.referer || '')"
                >
                  <div class="entry-key">
                    {{ t('eventsLog.panel.mainCard.entries.referer') }}
                  </div>
                  <div class="entry-value">
                    <div
                      class="entry-value-item"
                      ref="eventLogRefererRef"
                      v-b-tooltip="eventLogRefererTooltip"
                    >
                      <span class="ellipsis">
                        {{ eventLog.referer || '-' }}
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  class="entry entry-value-columns-1 challenge-type-entry is-clickable"
                  v-if="eventLog['challenge_type']"
                  @contextmenu="
                    openContextMenu($event, 'challenge_type', eventLog['challenge_type'])
                  "
                  @dblclick="doubleClick($event, 'challenge_type', eventLog['challenge_type'])"
                >
                  <div class="entry-key">
                    {{ t('eventsLog.panel.mainCard.entries.challengeType') }}
                  </div>
                  <div class="entry-value">
                    <div class="entry-value-item">
                      {{
                        t(
                          `eventsLog.panel.mainCard.entries.challengeTypeValue.${eventLog['challenge_type']}`
                        )
                      }}
                    </div>
                  </div>
                </div>
                <div
                  class="entry entry-value-columns-1 cache-entry is-clickable"
                  v-if="eventLog.headers?.['cache-control']"
                  @contextmenu="
                    openContextMenu(
                      $event,
                      'headers[&quot;cache-control&quot;]',
                      eventLog.headers['cache-control']
                    )
                  "
                  @dblclick="
                    doubleClick(
                      $event,
                      'headers[&quot;cache-control&quot;]',
                      eventLog.headers['cache-control']
                    )
                  "
                >
                  <div class="entry-key">
                    {{ t('eventsLog.panel.mainCard.entries.cache') }}
                  </div>
                  <div class="entry-value">
                    <div
                      class="entry-value-item"
                      ref="eventLogCacheControlRef"
                      v-b-tooltip="eventLogCacheControlTooltip"
                    >
                      <span class="ellipsis">
                        {{ eventLog.headers['cache-control'] }}
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  class="entry entry-value-columns-1 block-reasons-entry"
                  v-if="eventLog['block_reasons']?.length && !eventLog['challenge_type']"
                >
                  <div class="entry-key">
                    {{
                      t('eventsLog.panel.mainCard.entries.blockReasons', {
                        count: eventLog['block_reasons'].length,
                      })
                    }}
                  </div>
                  <div class="entry-value">
                    <events-log-panel-reason-badge
                      v-for="(reason, index) in eventLog['block_reasons']"
                      :key="index"
                      :reason="reason"
                      :url-path="eventLog.path"
                      @context-menu="openContextMenu($event.event, $event.property, $event.value)"
                      @double-click="doubleClick($event.event, $event.property, $event.value)"
                      type="block"
                    />
                  </div>
                </div>
                <div
                  class="entry entry-value-columns-1 monitor-reasons-entry"
                  v-if="eventLog['monitor_reasons']?.length && !eventLog['challenge_type']"
                >
                  <div class="entry-key">
                    {{
                      t('eventsLog.panel.mainCard.entries.monitorReasons', {
                        count: eventLog['monitor_reasons'].length,
                      })
                    }}
                  </div>
                  <div class="entry-value">
                    <events-log-panel-reason-badge
                      v-for="(reason, index) in eventLog['monitor_reasons']"
                      :key="index"
                      :reason="reason"
                      :url-path="eventLog.path"
                      @context-menu="openContextMenu($event.event, $event.property, $event.value)"
                      @double-click="doubleClick($event.event, $event.property, $event.value)"
                      type="monitor"
                    />
                  </div>
                </div>
                <div
                  class="entry entry-value-columns-1 tags-entry user-tags-entry"
                  v-if="sortedTagsUser.length"
                >
                  <div class="entry-key"></div>
                  <div class="entry-value">
                    <div class="tags-wrapper">
                      <rbz-custom-tag
                        v-for="tag in sortedTagsUser"
                        :key="tag"
                        :value="tag"
                        classes="is-clickable"
                        :double-click-enabled="true"
                        @contextmenu="openContextMenu($event, 'tags', tag)"
                        @dblclick="doubleClick($event, 'tags', tag)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <rbz-card-collapsible
            class="events-log-panel-card additional-details-card"
            data-qa="additional-details-card"
            :is-collapsed="isAdditionalDetailsCardCollapsed"
          >
            <template #title>
              {{ t('eventsLog.panel.additionalDetailsCard.title') }}
            </template>
            <template #content>
              <div class="card-content">
                <div class="entries-wrapper">
                  <div
                    class="entry entry-value-columns-2 upstream-entry"
                    v-if="eventLog['upstream_data']?.length"
                  >
                    <div class="entry-key">
                      {{ t('eventsLog.panel.additionalDetailsCard.entries.upstream') }}
                    </div>
                    <div class="entry-value">
                      <div
                        class="entry-value-item is-clickable upstream-address-entry"
                        v-for="(eventLogUpstreamEntry, index) in eventLog['upstream_data']"
                        :key="index"
                        @contextmenu="
                          openContextMenu($event, 'upstream_addr', eventLogUpstreamEntry.addr)
                        "
                        @dblclick="doubleClick($event, 'upstream_addr', eventLogUpstreamEntry.addr)"
                      >
                        <div class="entry-value-item-key">
                          {{
                            t('eventsLog.panel.additionalDetailsCard.entries.upstreamValue.address')
                          }}
                        </div>
                        <div
                          class="entry-value-item-value ellipsis"
                          ref="eventLogUpstreamAddressRefs"
                          v-b-tooltip="
                            Utils.elementTreeOverflow(eventLogUpstreamAddressRefs[index])
                              ? eventLogUpstreamEntry.addr
                              : ''
                          "
                        >
                          {{ eventLogUpstreamEntry.addr }}
                        </div>
                      </div>
                    </div>
                    <div class="entry-value">
                      <div
                        class="entry-value-item is-clickable upstream-status-entry"
                        v-for="(eventLogUpstreamEntry, index) in eventLog['upstream_data']"
                        :key="index"
                        @contextmenu="
                          openContextMenu($event, 'upstream_status', eventLogUpstreamEntry.status)
                        "
                        @dblclick="
                          doubleClick($event, 'upstream_status', eventLogUpstreamEntry.status)
                        "
                      >
                        <div class="entry-value-item-key">
                          {{
                            t('eventsLog.panel.additionalDetailsCard.entries.upstreamValue.status')
                          }}
                        </div>
                        <div class="entry-value-item-value status-box">
                          <icon-circle
                            :style="{
                              fill: getResponseCodeColor(eventLogUpstreamEntry.status),
                            }"
                            class="status-circle-icon"
                            :bypass-default-color="true"
                            circle-style="full"
                          />
                          {{ eventLogUpstreamEntry.status }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="entry entry-value-columns-2 size-entry">
                    <div class="entry-key">
                      {{ t('eventsLog.panel.additionalDetailsCard.entries.size') }}
                    </div>
                    <div class="entry-value">
                      <div
                        class="entry-value-item is-clickable upload-entry"
                        @contextmenu="
                          openContextMenu($event, 'request_length', eventLog['request_length'])
                        "
                        @dblclick="
                          doubleClick($event, 'request_length', eventLog['request_length'])
                        "
                      >
                        <div class="entry-value-item-key">
                          {{ t('eventsLog.panel.additionalDetailsCard.entries.sizeValue.upload') }}
                        </div>
                        <div class="entry-value-item-value">
                          {{ Utils.amountSuffixFormatterBytes(eventLog['request_length'], t) }}
                        </div>
                      </div>
                    </div>
                    <div class="entry-value">
                      <div
                        class="entry-value-item is-clickable download-entry"
                        @contextmenu="openContextMenu($event, 'bytes_sent', eventLog['bytes_sent'])"
                        @dblclick="doubleClick($event, 'bytes_sent', eventLog['bytes_sent'])"
                      >
                        <div class="entry-value-item-key">
                          {{
                            t('eventsLog.panel.additionalDetailsCard.entries.sizeValue.download')
                          }}
                        </div>
                        <div class="entry-value-item-value">
                          {{ Utils.amountSuffixFormatterBytes(eventLog['bytes_sent'], t) }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="entry time-entry"
                    :class="
                      eventLog['origin_time'] ? 'entry-value-columns-2' : 'entry-value-columns-1'
                    "
                  >
                    <div class="entry-key">
                      {{ t('eventsLog.panel.additionalDetailsCard.entries.time') }}
                    </div>
                    <div class="entry-value">
                      <div
                        class="entry-value-item is-clickable waap-time-entry"
                        @contextmenu="openContextMenu($event, 'waap_time', eventLog['waap_time'])"
                        @dblclick="doubleClick($event, 'waap_time', eventLog['waap_time'])"
                      >
                        <div class="entry-value-item-key">
                          {{ t('eventsLog.panel.additionalDetailsCard.entries.timeValue.waap') }}
                        </div>
                        <div class="entry-value-item-value">
                          {{ eventLog['waap_time'] }} {{ t('time.seconds') }}
                        </div>
                      </div>
                    </div>
                    <div class="entry-value" v-if="eventLog['origin_time']">
                      <div
                        class="entry-value-item is-clickable origin-time-entry"
                        @contextmenu="
                          openContextMenu($event, 'origin_time', eventLog['origin_time'])
                        "
                        @dblclick="doubleClick($event, 'origin_time', eventLog['origin_time'])"
                      >
                        <div class="entry-value-item-key">
                          {{ t('eventsLog.panel.additionalDetailsCard.entries.timeValue.origin') }}
                        </div>
                        <div class="entry-value-item-value">
                          {{ eventLog['origin_time'] }} {{ t('time.seconds') }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="entry entry-value-columns-1 protocol-entry is-clickable"
                    @contextmenu="openContextMenu($event, 'protocol', eventLog.protocol)"
                    @dblclick="doubleClick($event, 'protocol', eventLog.protocol)"
                  >
                    <div class="entry-key">
                      {{ t('eventsLog.panel.additionalDetailsCard.entries.protocol') }}
                    </div>
                    <div class="entry-value">
                      <div
                        class="entry-value-item"
                        ref="eventLogProtocolRef"
                        v-b-tooltip="eventLogProtocolTooltip"
                      >
                        <span
                          v-for="protocol in eventLog.protocol.split(' ')"
                          :key="protocol"
                          class="ellipsis"
                        >
                          {{ protocol }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="entry entry-value-columns-1 proxy-entry is-clickable"
                    @contextmenu="openContextMenu($event, 'proxy', eventLog.proxy)"
                    @dblclick="doubleClick($event, 'proxy', eventLog.proxy)"
                  >
                    <div class="entry-key">
                      {{ t('eventsLog.panel.additionalDetailsCard.entries.proxy') }}
                    </div>
                    <div class="entry-value">
                      <div
                        class="entry-value-item"
                        ref="eventLogProxyRef"
                        v-b-tooltip="eventLogProxyTooltip"
                      >
                        <span class="ellipsis">
                          {{ eventLog.proxy }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="entry entry-value-columns-1 waap-id-entry is-clickable"
                    v-if="eventLog['waap_id']"
                    @contextmenu="openContextMenu($event, 'waap_id', eventLog.waap_id)"
                    @dblclick="doubleClick($event, 'waap_id', eventLog.waap_id)"
                  >
                    <div class="entry-key">
                      {{ t('eventsLog.panel.additionalDetailsCard.entries.waapId') }}
                    </div>
                    <div class="entry-value">
                      <div
                        class="entry-value-item"
                        ref="eventLogWaapIdRef"
                        v-b-tooltip="eventLogWaapIdTooltip"
                      >
                        <span class="ellipsis">
                          {{ eventLog['waap_id'] }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="entry entry-value-columns-1 request-id-entry is-clickable"
                    @contextmenu="openContextMenu($event, 'request_id', eventLog['request_id'])"
                    @dblclick="doubleClick($event, 'request_id', eventLog['request_id'])"
                  >
                    <div class="entry-key">
                      {{ t('eventsLog.panel.additionalDetailsCard.entries.requestId') }}
                    </div>
                    <div class="entry-value">
                      <div
                        class="entry-value-item"
                        ref="eventLogRequestIdRef"
                        v-b-tooltip="eventLogRequestIdTooltip"
                      >
                        <span class="ellipsis">
                          {{ eventLog['request_id'] }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="entry entry-value-columns-1 session-id-entry is-clickable"
                    @contextmenu="openContextMenu($event, 'session', eventLog.session)"
                    @dblclick="doubleClick($event, 'session', eventLog.session)"
                  >
                    <div class="entry-key">
                      {{ t('eventsLog.panel.additionalDetailsCard.entries.sessionId') }}
                    </div>
                    <div class="entry-value">
                      <div
                        class="entry-value-item"
                        ref="eventLogSessionRef"
                        v-b-tooltip="eventLogSessionTooltip"
                      >
                        <span class="ellipsis">
                          {{ eventLog.session }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="entry entry-value-columns-1 revision-id-entry is-clickable"
                    @contextmenu="openContextMenu($event, 'revision', eventLog.revision)"
                    @dblclick="doubleClick($event, 'revision', eventLog.revision)"
                  >
                    <div class="entry-key">
                      {{ t('eventsLog.panel.additionalDetailsCard.entries.revisionId') }}
                    </div>
                    <div class="entry-value">
                      <div
                        class="entry-value-item"
                        ref="eventLogRevisionRef"
                        v-b-tooltip="eventLogRevisionTooltip"
                      >
                        <span class="ellipsis">
                          {{ eventLog.revision }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="entry entry-value-columns-1 tags-entry system-tags-entry"
                    v-if="sortedTagsSystem.length"
                  >
                    <div class="entry-key"></div>
                    <div class="entry-value">
                      <div class="tags-wrapper">
                        <rbz-custom-tag
                          v-for="tag in sortedTagsSystem"
                          :key="tag"
                          :value="tag"
                          classes="is-clickable"
                          :double-click-enabled="true"
                          @contextmenu="openContextMenu($event, 'tags', tag)"
                          @dblclick="doubleClick($event, 'tags', tag)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="arguments-cookies-headers-wrapper" v-if="argsCookiesHeadersTabs.length">
                  <tabs-wrapper
                    :tabs="argsCookiesHeadersTabs"
                    :tab-header-grows="false"
                    :active="selectedTab?.title"
                    @selected-tab="
                      isDataOptimized ? reloadEventLogData($event as ArgsCookiesHeadersTab) : null
                    "
                  >
                    <template v-for="tab in argsCookiesHeadersTabs" :key="tab.title" #[tab.title]>
                      <div class="entries-wrapper">
                        <template v-for="(entryValue, entryKey, index) in eventLog[tab.key]">
                          <div
                            class="entry is-clickable"
                            v-if="!isDataOptimized || tab.key !== 'arguments' || index <= 9"
                            :key="`${tab.key}-${entryKey}`"
                            @contextmenu="
                              openContextMenu(
                                $event,
                                `${tab.key}[&quot;${entryKey}&quot;]`,
                                entryValue
                              )
                            "
                            @dblclick="
                              doubleClick($event, `${tab.key}[&quot;${entryKey}&quot;]`, entryValue)
                            "
                          >
                            <div
                              class="entry-key ellipsis"
                              :ref="
                                (el) =>
                                  (entryKeyRefs[`${tab}-${entryKey}`] = el as HTMLElement | null)
                              "
                              v-b-tooltip="
                                Utils.elementTreeOverflow(
                                  entryKeyRefs[`${tab}-${entryKey}`] as Partial<HTMLElement>
                                )
                                  ? entryKey
                                  : ''
                              "
                            >
                              {{ entryKey }}
                            </div>
                            <div class="entry-value">
                              <div
                                class="entry-value-item"
                                :ref="
                                  (el) =>
                                    (entryValueRefs[`${tab}-${entryKey}`] =
                                      el as HTMLElement | null)
                                "
                                v-b-tooltip="
                                  Utils.elementTreeOverflow(
                                    entryValueRefs[`${tab}-${entryKey}`] as Partial<HTMLElement>
                                  )
                                    ? entryValue
                                    : ''
                                "
                              >
                                {{ entryValue }}
                              </div>
                            </div>
                          </div>
                        </template>
                        <rbz-form-button
                          v-if="
                            isDataOptimized &&
                            tab.key === 'arguments' &&
                            _.size(eventLog.arguments) > 10
                          "
                          :label="
                            $t('eventsLog.panel.additionalDetailsCard.showAllArgumentsButton')
                          "
                          class="show-all-arguments-button"
                          data-qa="show-all-arguments-button"
                          @button-click="onShowMoreArgumentsButtonClick()"
                        />
                        <rbz-loader
                          v-if="
                            isDataOptimized &&
                            tab.key === 'arguments' &&
                            _.isEmpty(eventLog.arguments)
                          "
                          :loading="!!isArgumentsListLoading"
                          :data-exists="!_.isEmpty(eventLog.arguments)"
                          height="100%"
                        />
                      </div>
                    </template>
                  </tabs-wrapper>
                </div>
              </div>
            </template>
          </rbz-card-collapsible>
          <rbz-card-collapsible
            v-if="eventLog.messages?.length"
            class="events-log-panel-card messages-card"
            data-qa="messages-card"
          >
            <template #title>
              {{ t('eventsLog.panel.messagesCard.title') }}
            </template>
            <template #content>
              <div class="card-content">
                <div class="messages-wrapper">
                  <template v-for="(messageValue, index) in eventLog.messages" :key="index">
                    <div
                      class="message-row is-clickable"
                      @contextmenu="openContextMenu($event, 'messages', messageValue)"
                      @dblclick="doubleClick($event, 'messages', messageValue)"
                    >
                      {{ messageValue }}
                    </div>
                    <div v-if="index < eventLog.messages.length - 1">
                      <layout-divider-line color="light-gray" />
                    </div>
                  </template>
                </div>
              </div>
            </template>
          </rbz-card-collapsible>
        </template>
        <template v-else>
          <rbz-table
            :columns="argumentsTableColumns"
            :table-data="argumentsTableData"
            class="arguments-table"
            ref="argumentsTableRef"
            data-qa="arguments-table"
            :rows-per-page="'all'"
            :show-filter-row="true"
            :show-new-button="false"
            :hide-header-row="true"
            :show-buttons-column="false"
            :show-narrow-column="false"
            :sticky-top-navbar="true"
            :sticky-header="true"
            @download-data="downloadArgumentsData"
          >
          </rbz-table>
          <rbz-loader
            v-if="!!isArgumentsListLoading && _.isEmpty(eventLog.arguments)"
            :loading="!!isArgumentsListLoading"
            :data-exists="!_.isEmpty(eventLog.arguments)"
            height="100%"
          />
        </template>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { EventLog, GenericObject, Tab } from '@/types';
import { useI18n } from 'vue-i18n';
import { computed, nextTick, ref, watch } from 'vue';
import RbzCardCollapsible from 'ui-component-library/rbz/components/RbzCardCollapsible.vue';
import RbzCustomTag from '@/components/RbzCustomTag.vue';
import IconCircle from 'ui-component-library/assets/icons/IconCircle.vue';
import { RESPONSE_CODE_COLOR_PALETTE } from '@/helpers/Consts';
import LayoutDividerLine from 'ui-component-library/rbz/components/LayoutDividerLine.vue';
import _ from 'lodash';
import TabsWrapper from 'ui-component-library/rbz/components/TabsWrapper.vue';
import Utils from 'ui-component-library/helpers/Utils';
import RbzFormButton from '@/components/RbzFormButton.vue';
import EventsLogPanelReasonBadge from '@/components/EventsLogPanelReasonBadge.vue';
import RbzLoader from '@/components/RbzLoader.vue';
import RequestsUtils from '@/helpers/RequestsUtils';
import { AxiosError } from 'axios';
import { RbzTableColumnOptions } from 'ui-component-library/rbz/types';
import RbzTable from 'ui-component-library/rbz/components/RbzTable.vue';
import { ENV } from '@/constants';
import { useTagsStore } from '@/store/TagsStore';

const { t } = useI18n();
const tagsStore = useTagsStore();

type ArgsCookiesHeadersTab = Tab & {
  key: 'headers' | 'cookies' | 'arguments';
};

interface EventsLogPanelProps {
  eventLog: EventLog;
  anchorTop?: number;
  previousEventLogDisabled?: boolean;
  nextEventLogDisabled?: boolean;
  isDataOptimized: boolean;
  filtersQuery: string;
}

const props = defineProps<EventsLogPanelProps>();

interface EventsLogPanelEmits {
  (e: 'previous-log'): void;

  (e: 'next-log'): void;

  (e: 'close-panel'): void;

  (
    e: 'context-menu',
    { event, property, value }: { event: Event; property: string; value: string | number }
  ): void;

  (
    e: 'double-click',
    { event, property, value }: { event: Event; property: string; value: string | number }
  ): void;

  (e: 'update-event-log', eventLog: EventLog): void;
}

const emit = defineEmits<EventsLogPanelEmits>();

const panelRef = ref(null);

const eventLogDateTime = computed(() => {
  const splitTimestamp = props.eventLog.timestamp.split('.');
  splitTimestamp[1] = splitTimestamp[1].slice(0, 2);
  return splitTimestamp.join('.').replace('T', ' ');
});

const argsCookiesHeadersTabs = computed((): ArgsCookiesHeadersTab[] => {
  const argumentsTab: ArgsCookiesHeadersTab = {
    title: t('eventsLog.panel.additionalDetailsCard.arguments'),
    key: 'arguments',
  };
  let tabs: ArgsCookiesHeadersTab[] = [
    {
      title: t('eventsLog.panel.additionalDetailsCard.headers'),
      key: 'headers',
    },
    {
      title: t('eventsLog.panel.additionalDetailsCard.cookies'),
      key: 'cookies',
    },
    argumentsTab,
  ];
  tabs = _.filter(tabs, (tab: ArgsCookiesHeadersTab) => {
    return props.eventLog[tab.key] && Object.keys(props.eventLog[tab.key]).length;
  }) as ArgsCookiesHeadersTab[];
  const argumentsTabExists = _.some(tabs, (tab: ArgsCookiesHeadersTab) => {
    return tab.key === argumentsTab.key;
  });
  if (props.isDataOptimized && !props.eventLog.is_arguments_null && !argumentsTabExists) {
    tabs.push(argumentsTab);
  }
  return tabs;
});

const sortedTagsUser = computed((): string[] => {
  return _.cloneDeep(props.eventLog.tags.user)
    .map((tag) => tagsStore.normalizeTag(tag))
    .sort();
});

const sortedTagsSystem = computed((): string[] => {
  return _.cloneDeep(props.eventLog.tags.system)
    .map((tag) => tagsStore.normalizeTag(tag))
    .sort();
});

const openContextMenu = (event: Event, property: string, value: string | number) => {
  emit('context-menu', { event, property, value });
};

const doubleClick = (event: Event, property: string, value: string | number) => {
  emit('double-click', { event, property, value });
};

const getResponseCodeColor = (responseCode: number): string => {
  const colorPalette = RESPONSE_CODE_COLOR_PALETTE as GenericObject;
  const colorClass = `${responseCode?.toString().slice(0, -2)}xx`;
  return colorPalette[colorClass]?.[0] || '#000';
};

const eventLogIpRef = ref<HTMLElement | null>(null);
const eventLogIpTooltip = computed(() => {
  return Utils.elementTreeOverflow(eventLogIpRef.value as Partial<HTMLElement>)
    ? props.eventLog.ip
    : '';
});
const eventLogAsnRef = ref<HTMLElement | null>(null);
const eventLogAsnTooltip = computed(() => {
  return Utils.elementTreeOverflow(eventLogAsnRef.value as Partial<HTMLElement>)
    ? props.eventLog.asn
    : '';
});
const eventLogCountryRef = ref<HTMLElement | null>(null);
const eventLogCountryTooltip = computed(() => {
  return Utils.elementTreeOverflow(eventLogCountryRef.value as Partial<HTMLElement>)
    ? props.eventLog.country
    : '';
});
const eventLogOrganizationRef = ref<HTMLElement | null>(null);
const eventLogOrganizationTooltip = computed(() => {
  return Utils.elementTreeOverflow(eventLogOrganizationRef.value as Partial<HTMLElement>)
    ? props.eventLog.organization
    : '';
});
const eventLogUserAgentRef = ref<HTMLElement | null>(null);
const eventLogUserAgentTooltip = computed(() => {
  return Utils.elementTreeOverflow(eventLogUserAgentRef.value as Partial<HTMLElement>)
    ? props.eventLog['user_agent']
    : '';
});
const eventLogHostRef = ref<HTMLElement | null>(null);
const eventLogHostTooltip = computed(() => {
  return Utils.elementTreeOverflow(eventLogHostRef.value as Partial<HTMLElement>)
    ? props.eventLog.host
    : '';
});
const eventLogPathRef = ref<HTMLElement | null>(null);
const eventLogPathTooltip = computed(() => {
  return Utils.elementTreeOverflow(eventLogPathRef.value as Partial<HTMLElement>)
    ? props.eventLog.path
    : '';
});
const eventLogQueryRef = ref<HTMLElement | null>(null);
const eventLogQueryTooltip = computed(() => {
  return Utils.elementTreeOverflow(eventLogQueryRef.value as Partial<HTMLElement>)
    ? props.eventLog.query
    : '';
});
const eventLogRefererRef = ref<HTMLElement | null>(null);
const eventLogRefererTooltip = computed(() => {
  return Utils.elementTreeOverflow(eventLogRefererRef.value as Partial<HTMLElement>)
    ? props.eventLog.referer
    : '';
});
const eventLogCacheControlRef = ref<HTMLElement | null>(null);
const eventLogCacheControlTooltip = computed(() => {
  return Utils.elementTreeOverflow(eventLogCacheControlRef.value as Partial<HTMLElement>)
    ? props.eventLog.headers['cache-control']
    : '';
});
const eventLogUpstreamAddressRefs = ref<HTMLElement[]>([]);
const eventLogProtocolRef = ref<HTMLElement | null>(null);
const eventLogProtocolTooltip = computed(() => {
  return Utils.elementTreeOverflow(eventLogProtocolRef.value as Partial<HTMLElement>)
    ? props.eventLog.protocol
    : '';
});
const eventLogProxyRef = ref<HTMLElement | null>(null);
const eventLogProxyTooltip = computed(() => {
  return Utils.elementTreeOverflow(eventLogProxyRef.value as Partial<HTMLElement>)
    ? props.eventLog.proxy
    : '';
});
const eventLogWaapIdRef = ref<HTMLElement | null>(null);
const eventLogWaapIdTooltip = computed(() => {
  return Utils.elementTreeOverflow(eventLogWaapIdRef.value as Partial<HTMLElement>)
    ? props.eventLog['waap_id']
    : '';
});
const eventLogRequestIdRef = ref<HTMLElement | null>(null);
const eventLogRequestIdTooltip = computed(() => {
  return Utils.elementTreeOverflow(eventLogRequestIdRef.value as Partial<HTMLElement>)
    ? props.eventLog['request_id']
    : '';
});
const eventLogSessionRef = ref<HTMLElement | null>(null);
const eventLogSessionTooltip = computed(() => {
  return Utils.elementTreeOverflow(eventLogSessionRef.value as Partial<HTMLElement>)
    ? props.eventLog.session
    : '';
});
const eventLogRevisionRef = ref<HTMLElement | null>(null);
const eventLogRevisionTooltip = computed(() => {
  return Utils.elementTreeOverflow(eventLogRevisionRef.value as Partial<HTMLElement>)
    ? props.eventLog.revision
    : '';
});
const entryKeyRefs = ref<Record<string, HTMLElement | null>>({});
const entryValueRefs = ref<Record<string, HTMLElement | null>>({});
const isArgumentsListLoading = ref(false);
const selectedTab = ref(null);
const isArgumentsContent = ref(false);
const isAdditionalDetailsCardCollapsed = ref(true);
const argumentsTableRef = ref(null);
const argumentsTableColumns = ref<RbzTableColumnOptions[]>([
  {
    id: 'key',
    title: t('eventsLog.panel.additionalDetailsCard.argumentsTable.key'),
    fieldNames: ['key'],
    isSearchable: true,
    classes: 'width-140px',
    cellContentClasses: 'ellipsis',
  },
  {
    id: 'value',
    title: t('eventsLog.panel.additionalDetailsCard.argumentsTable.value'),
    fieldNames: ['value'],
    isSearchable: true,
    cellContentClasses: 'ellipsis',
  },
]);
const reloadEventLogData = async (tab?: ArgsCookiesHeadersTab) => {
  let data: EventLog = null;
  const tabs = argsCookiesHeadersTabs.value;
  tab = tab || selectedTab.value;
  // Ensure the tab exists in the available tabs; otherwise, default to the first tab
  if (!tab || !_.some(tabs, (tab: ArgsCookiesHeadersTab) => tab.key === selectedTab.value?.key)) {
    tab = tabs[0];
  }
  if (tab) {
    selectedTab.value = tab;
    if (tab.key === 'arguments' && _.isEmpty(props.eventLog.arguments)) {
      isArgumentsListLoading.value = true;
      const response = await RequestsUtils.sendRequest({
        methodName: 'GET',
        url: `data/logs?save_history=false&filters=${buildFiltersQuery()}`,
        config: {
          headers: {
            provider: ENV.VITE_LOGS_DB_PROVIDER,
            syntax: 'string_query',
          },
        },
        onFail: (error: AxiosError<{ detail?: string }>) => {
          const data = error.response?.data;
          if (data?.detail) {
            Utils.toast({
              message: data.detail,
              type: 'is-danger',
            });
          }
        },
      });
      data = response?.data?.data?.results[0] || null;
      isArgumentsListLoading.value = false;
    }
  }
  if (data) {
    emit('update-event-log', data);
  }
};

const buildFiltersQuery = (): string => {
  const filters = props.filtersQuery.split(/, /);
  const timestampFilter = filters
    .find((filter) => {
      return filter.trim().startsWith('timestamp');
    })
    .trim();
  return encodeURIComponent(`request_id="${props.eventLog.request_id}", ${timestampFilter}`);
};

const argumentsTableData = computed(() => {
  return _.map(props.eventLog.arguments, (argumentValue, argumentKey) => {
    return {
      key: argumentKey,
      value: argumentValue,
    };
  });
});

const downloadArgumentsData = () => {
  Utils.downloadFile('events-log-arguments', 'json', argumentsTableData.value);
};

const onShowMoreArgumentsButtonClick = () => {
  isArgumentsContent.value = true;
  nextTick(() => {
    argumentsTableRef.value.tableRef.scrollIntoView();
  });
};

watch(
  () => props.eventLog.request_id,
  () => {
    reloadEventLogData();
  }
);
</script>

<style scoped lang="scss">
@use 'ui-component-library/assets/styles/main';
@use 'ui-component-library/assets/styles/colors' as colors;
@use 'sass:map';

$panel-width: 892px;
$panel-padding: 24px;

.events-log-panel-wrapper {
  background: map.get(colors.$colors, 'alabaster');
  border-radius: 2px;
  bottom: 0;
  box-shadow: -8px 2px 24px 0 rgb(0, 0, 0, 0.16);
  box-sizing: content-box;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: $panel-padding;
  position: fixed;
  right: 32px;
  top: var(--anchor-top);
  width: $panel-width;
  z-index: 1;
}

:deep(.return-to-panel-content-button) {
  background-color: transparent;
}

.events-log-panel-content {
  overflow: hidden auto;
  padding-right: 6px;
}

.top-navbar {
  align-items: center;
  display: flex;
  height: 36px;
  justify-content: space-between;

  .buttons-wrapper {
    display: flex;
    gap: 8px;
  }

  .navigation-buttons {
    display: flex;
  }

  :deep(.panel-button) {
    background-color: transparent;
    border: 0;
    height: 24px;
    padding: 0;
    width: 24px;

    &.icon-only {
      padding: 0;
    }

    &:hover {
      background-color: map.get(colors.$colors, 'mountain-meadow-light');
    }
  }
}

.events-log-panel-card,
.rbz-card.events-log-panel-card {
  border: 1px solid map.get(colors.$colors, 'silver');
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: auto;
}

.main-card {
  height: auto;
  padding-bottom: 7px;

  .date-wrapper {
    align-items: flex-end;
    align-self: stretch;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 16px 16px 8px;

    .date-value {
      color: map.get(colors.$colors, 'shuttle-gray');
    }
  }
}

:deep(.rbz-card-content) {
  padding: 0 0 7px;
}

.messages-card {
  .messages-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .message-row {
    color: map.get(colors.$colors, 'bright-gray');
    display: flex;
    min-height: 1.5rem;
    word-break: break-all;
  }
}

.card-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 12px;
  padding: 16px;
}

.entries-wrapper {
  $entry-key-width: 140px;

  display: flex;
  flex-direction: column;
  gap: 8px;

  .entry {
    display: grid;
    column-gap: 8px;
    overflow: hidden;
    padding: 4px 0;
  }

  .entry:not(:last-child) {
    border-bottom: 1px solid map.get(colors.$colors, 'link-water');
  }

  .entry-value-columns-1 {
    grid-template-columns: $entry-key-width 1fr;
  }

  .entry-value-columns-2 {
    grid-template-columns: $entry-key-width 1fr 1fr;
  }

  .entry-value-columns-3 {
    grid-template-columns: $entry-key-width 1fr 1fr 1fr;
  }

  .entry-key {
    @extend .rbz-text-large-medium;

    color: map.get(colors.$colors, 'fun-blue');
    padding: 0 16px 0 8px;
  }

  .entry-value {
    color: map.get(colors.$colors, 'shuttle-gray');
    overflow: hidden;
    word-break: break-word;
  }
}

.user-agent-entry {
  .entry-value {
    .entry-value-item {
      height: auto;
    }
  }
}

.entry-value-item {
  align-items: center;
  display: flex;
  height: 24px;

  .entry-value-item-key {
    @extend .rbz-text-medium;

    color: map.get(colors.$colors, 'fun-blue');
    max-width: 120px;
    min-width: 120px;
    width: 120px;
  }

  .entry-value-item-value {
    @extend .rbz-text-regular;

    color: map.get(colors.$colors, 'shuttle-gray');
    word-break: break-word;
  }
}

.tags-wrapper {
  display: flex;
  flex-grow: 1;
  flex-wrap: wrap;
  gap: 8px;
}

.status-box {
  align-items: center;
  display: flex;
  gap: 4px;
}

.ids-entry {
  .entry-value-items {
    .entry-value-items-row.pipe-divider {
      gap: 24px;
    }

    .entry-value-item {
      max-width: 35%;
    }
  }
}

.block-reasons-entry,
.monitor-reasons-entry {
  .entry-key {
    padding-top: 3px;
  }

  .entry-value {
    display: flex;
    flex-direction: column;
    gap: 4px;
    overflow: hidden;
  }
}

.arguments-cookies-headers-wrapper {
  .entries-wrapper {
    gap: 0;
    min-height: 100px;
    position: relative;

    .entry {
      align-items: center;
      border-bottom: 0;
      grid-template-columns: 200px 1fr;
      padding: 3px 0;
    }

    .show-all-arguments-button {
      align-items: center;
      display: flex;
      justify-content: center;
      padding: 16px 0 24px;
    }
  }

  .entry-key {
    @extend .rbz-text-medium;
  }

  .entry-value-item {
    -webkit-box-orient: vertical; /* stylelint-disable-line property-no-vendor-prefix */
    display: -webkit-box; /* stylelint-disable-line value-no-vendor-prefix */
    height: auto;
    -webkit-line-clamp: 4;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

:deep(.arguments-table) {
  .top-navbar {
    background-color: map.get(colors.$colors, 'alabaster');
  }

  .rbz-table-head {
    background-color: map.get(colors.$colors, 'alabaster');
  }

  .filter-cell {
    border-bottom: 0;
  }

  .filter-cell:last-child {
    width: 100%;
  }

  .data-cell {
    border-bottom: 0;
    height: auto;
    padding: 0;

    .data-cell-content {
      display: -webkit-box; /* stylelint-disable-line value-no-vendor-prefix */
      padding: 3px 9px;
      text-wrap: wrap;
      overflow-wrap: break-word;
      -webkit-box-orient: vertical; /* stylelint-disable-line property-no-vendor-prefix */
      -webkit-line-clamp: 4;
    }

    .data-cell-content span {
      display: block;
    }
  }

  .data-row:hover {
    background-color: transparent;
  }

  .icon-only {
    background-color: transparent;
  }

  .icon-only:hover {
    background-color: map.get(colors.$colors, 'mountain-meadow-light');
  }
}
</style>
